import { useState } from "react";
import { useTranslation } from 'react-i18next';
import SimpleHeader from "../../components/layout/SimpleHeader";
import List from "../../components/statistics/student-retire/List";
import TableContainer from "../../components/statistics/student-retire/TableContainer";
import TabItem from "../../components/statistics/TabItem";

export enum Contents {
  Table,
  List
}

const StatisticsStudentRetire = () => {
  const { t } = useTranslation();
  const [content, setContent] = useState<Contents>(Contents.Table);

  const renderContent = () => {
    switch (content) {
      case Contents.Table:
        return <TableContainer />;
      case Contents.List:
        return <List />;
    }
  }

  return (
    <>
    <SimpleHeader
      iconFile="icon-statistics-big.svg"
      parentMenu={t('common.menu.statistics')}
      currentMenu={t('statistics.studentRetire.title1')}
      onlyTitle={true}
    />
    <div className="content scrollbar">
      <div className="col-frame">
        <div className="comm-tab__line">
          <ul>
            <TabItem
              currentContent={content}
              onSetContent={setContent}
              tabContent={Contents.Table}
              tabLabel={t('statistics.studentEnrollMonth.tab1')}
            />
            <TabItem
              currentContent={content}
              onSetContent={setContent}
              tabContent={Contents.List}
              tabLabel={t('statistics.attendance.Tab2')}
            />
          </ul>
        </div>
        <div>
          {renderContent()}
        </div>
      </div>
    </div>
    </>
  );
}

export default StatisticsStudentRetire;
